import { Autocomplete, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../redux/types'

interface IRole {
  id: number
  name: string
}

function RoleAutocomplete({ value, handleInputChange }: any) {
  const { t } = useTranslation(['global'])

  const { roles } = useSelector((state: IRootState) => state.role)
  const { errorForm, msgForm } = useSelector((state: IRootState) => state.validator)

  const handleAutoCompleteChange = (role: IRole | null) => {
    handleInputChange('role', role)
  }

  return (
    <Autocomplete
      id="autocomplete-roles"
      value={value}
      onChange={(_, value) => handleAutoCompleteChange(value)}
      options={roles.filter((role: any) => role.code > 3)}
      getOptionLabel={(option: any) => (option.id !== undefined ? option.name : '')}
      renderInput={params => (
        <TextField
          required
          {...params}
          label={t('roles')}
          variant="filled"
          InputLabelProps={{ shrink: true }}
          error={errorForm.role}
          helperText={msgForm.role}
        />
      )}
    />
  )
}

export default RoleAutocomplete
